<template>
  <div style="height:100%;width:100%;overflow:auto;">
    <el-container v-loading="loading" style="background:white;">
      <el-header style="background:white;border: 0px;height:116px;">
        <img src="@/assets/logo_01.svg" style="height:68px;width:68px;padding:22px;" alt="Nikon" />
      </el-header>
      <el-container style="min-height:740px;min-width:350px;">
        <el-main :class="{ mobile: isMobile, notMobile: !isMobile }">
          <!--ログイン入力-->
          <el-row class="width100" style="justify-content:center;margin-top:-60px;">
            <img src="@/assets/AppIcon_for_Web.png">
          </el-row>
          <el-row>
            <el-form label-width="120px" label-position="top" @submit.prevent>
              <el-form-item label="農家ID" class="font_18">
                <el-input ref="farmerid" class="login font_18" v-model="farmer_id" placeholder="farmer_id" :maxlength="64"
                  :class="{ 'input-mobile': isMobile }" />
              </el-form-item>
              <el-form-item label="メールアドレス">
                <el-input ref="mailaddress" class="font_18" type="email" v-model="mailaddress" placeholder="mail@address"
                  :maxlength="maxLength" :class="{ 'input-mobile': isMobile }" />
              </el-form-item>
              <el-form-item label="パスワード">
                <el-input v-if="!showPassword" ref="password" class="font_18" type="password" v-model="password"
                  placeholder="password" :suffix-icon="IconEyeSlash" :minlength="8" :maxlength="maxLength"
                  :class="{ 'input-mobile': isMobile }" @keypress.enter="click_signin" />
                <el-input v-if="showPassword" ref="password" class="font_18" v-model="password" placeholder="password"
                  :suffix-icon="IconEye" :minlength="8" :maxlength="maxLength" :class="{ 'input-mobile': isMobile }"
                  @keypress.enter="click_signin" />
                <div style="width:0px;height:50px;position:relative;">
                  <el-button class="btn-height" type="primary" @click="showPassword = !showPassword"
                    style="position:absolute;left:-33px;top:0px;opacity:0;" />
                </div>
              </el-form-item>
              <el-form-item>
                <el-button id="login_button" ref="login" class="btn-width btn-height" round @click="click_signin"
                  :class="{ 'btn-mobile': isMobile }">ログイン</el-button>
              </el-form-item>
            </el-form>
          </el-row>
          <el-row v-if="message !== ''">
            <p>{{ message }}</p>
          </el-row>
          <el-row v-if="message !== ''" style="margin: 0 0 20px 0;">
            <forgot-password :isMobile="isMobile" />
          </el-row>
          <el-row v-if="message === ''" style="margin: 20px 0px 20px 0px;">
            <forgot-password :isMobile="isMobile" />
          </el-row>
        </el-main>
        <el-footer>
          <el-row style="margin-bottom:0px;">
            <span style="font-size:14px;">{{ version_text }}</span>
          </el-row>
          <el-row style="margin-bottom:0px;">
            <span style="font-size:12px;">{{ copyright_text_01 }}</span>
          </el-row>
          <el-row>
            <span style="font-size:12px;">{{ copyright_text_02 }}</span>
          </el-row>
        </el-footer>
      </el-container>
    </el-container>

    <!--パスワード強制変更-->
    <el-dialog :width="dialogWidth" v-model="dialogVisible" title="新しいパスワードを入力してください" destroy-on-close>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" label-position="left" @submit.prevent>
        <el-form-item label="パスワード" prop="newPassword">
          <el-input v-if="!showPasswordDialog" type="password" v-model="form.newPassword" placeholder="password"
            :suffix-icon="IconEyeSlash" :minlength="8" :maxlength="maxLength" :class="{ 'input-mobile-new': isMobile }" />
          <el-input v-if="showPasswordDialog" v-model="form.newPassword" placeholder="password" :suffix-icon="IconEye"
            :minlength="8" :maxlength="maxLength" :class="{ 'input-mobile-new': isMobile }" />
          <div style="width:0px;height:50px;position:relative;">
            <el-button class="btn-height" type="primary" @click="showPasswordDialog = !showPasswordDialog"
              style="position:absolute;left:-33px;top:0px;opacity:0;" />
          </div>
        </el-form-item>
        <el-row style="justify-content: left;">
          <p style="text-align:left">[パスワードポリシー]<br>
            ・パスワードは8文字以上入力してください。<br>
            ・数字、英大文字、英小文字を1文字以上含めてください。<br>
            ・以下の特殊文字のいずれか1文字以上を含めてください。<br>
            特殊文字： ^$*.[]{}()?-&quot;!@#%&amp;/\,&gt;&lt;&#39;:;|_~`+=</p>
        </el-row>
      </el-form>
      <el-row>
        <p style="color: #F56C6C;">{{ confirmMessage }}</p>
      </el-row>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="button-style-short" color="#ffdf5e" type="primary" @click="click_confirm_signin">
            変更
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { CognitoUserAccessor } from "./js/cognito-login";
import { signout } from "../views/js/cognito";
import ForgotPassword from "@/components/ForgotPassword.vue";
import ConstParam from './js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules';

export default {
  components: {
    ForgotPassword,
  },
  created() {
    this.isMobile = this.checkUserAgent();
    if (this.isMobile) {
      this.dialogWidth = "100%"
    }
  },
  mounted() {
    this.$refs.farmerid.focus()
    // パラメータ保存(権限)
    let init = -1 // 未設定
    this.$store.commit('setUserType', init);
  },
  data() {
    return {
      dialogWidth: '50%',
      isMobile: false,
      IconEye: shallowRef(icons.IconEye),
      IconEyeSlash: shallowRef(icons.IconEyeSlash),
      showPassword: false,
      showPasswordDialog: false,
      maxLength: ConstParam.maxLength,
      loading: false,
      // 定数値
      version_text: ConstParam.version_text,
      copyright_text_01: ConstParam.copyright_text_01,
      copyright_text_02: ConstParam.copyright_text_02,
      // その他
      message: "",
      farmer_id: "",
      mailaddress: "",
      password: "",
      id_token: "",

      // Cognitoオブジェクト.
      cognitoUser: {},

      // パスワード強制変更.
      form: {
        newPassword: "",
      },
      rules: {
        newPassword: [
          { required: true, message: 'この項目は入力が必須です。' },
          { min: 8, message: '8文字以上で入力してください。' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
          { pattern: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S+$/, message: '大文字・小文字・数字、特殊文字をそれぞれ１文字以上含む必要があります。' },
        ]
      },
      dialogVisible: false,
      confirmMessage: "",
    };
  },
  methods: {
    passwordMessage(message) {
      this.$alert(message, "", {
        confirmButtonText: 'もう一度実行'
      }).catch(() => {
        return
      });
    },
    checkUserAgent() {
      if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        return true;
      } else {
        return false;
      }
    },
    async click_signin() {
      try {
        // ローディング
        this.loading = true;
        // ログイン情報.
        const username = this.farmer_id + "@" + this.mailaddress;
        const password = this.password;

        // サインイン.
        const cognitoUser = new CognitoUserAccessor();
        cognitoUser.init(username, password);
        const result = await cognitoUser.signin();

        // ローディング
        this.loading = false;
        // 結果判定.
        if ("newPasswordRequired" in result) {
          // 再設定ダイアログ表示.
          this.cognitoUser.object = cognitoUser;
          this.form.newPassword = "";
          this.confirmMessage = "";
          this.showPasswordDialog = false;
          this.dialogVisible = true;
        } else {
          // 成功.
          this.id_token = result.idToken.jwtToken;
          this.message = "サインインに成功しました";
          // イベントフィルターのクリア
          this.$store.commit('setFilterParams', { save: false, filter_params: [] });
          // ルートへ遷移
          if (!this.isMobile) {
            this.$router.replace('/')
          } else {
            // サインアウトしてアプリストアを開く
            try {
              await signout();
              this.$router.push('/phoneappstore')
            } catch {
              this.$router.push('/phoneappstore')
            }
          }
        }
      } catch (e) {
        // ローディング
        this.loading = false;
        // 失敗.
        this.message = "農家ID、メールアドレス、パスワードが間違っています";
      }
    },
    click_confirm_signin() {
      const re = new RegExp(ConstParam.password_reg)
      if (!re.test(this.form.newPassword)) {
        this.passwordMessage(ConstParam.password_error)
        return
      }
      this.$refs.formRef.validate((valid) => {
        this.confirmMessage = "";
        if (!valid) {
          this.confirmMessage = '赤枠表示部分の入力内容を修正してください。';
          return;
        }
        this.passwordCahnge();
      })
    },
    async passwordCahnge() {
      try {
        // パスワード変更.
        const cognitoUser = this.cognitoUser.object;
        const newPassword = this.form.newPassword;
        await cognitoUser.newPasswordChallenge(newPassword);

        // ダイアログ閉じる.
        this.dialogVisible = false;

        // パスワード認証再実行.
        this.password = this.form.newPassword;
        this.click_signin();
      } catch (e) {
        this.confirmMessage = "パスワード変更に失敗しました";
      }
    }
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-input {
  width: 412px;
  height: 50px;
}

.btn-height {
  height: 50px;
}

.btn-width {
  width: 412px;
}

:root .el-main {
  --el-main-padding: 0px 0px 0px 0px !important;
}


#login_button {
  color: #383838;
  background: #ffdf5e;
  /* margin-top: 58px; */
  margin-top: 30px;
}

#oval {
  width: 186px;
  height: 186px;
  background: #d8d8d8;
  border-radius: 50%;
}


.mobile {
  padding: 45px 5px 10px 5px !important;
}

.notMobile {
  padding: 44px 74px 0 74px !important;
}

.input-mobile {
  width: 280px !important;
}

.input-mobile-new {
  width: 210px !important;
  font-size: 16px;
}

.btn-mobile {
  width: 280px;
}
</style>